import jwtDecode from "jwt-decode";

export const getCurrentUser = () =>{
    const jwt = localStorage.getItem("tokenjwt") || '';
    return jwtDecode(jwt);
}

export default {
    getCurrentUser,
}